export default {
  pageTitle: 'Task List',
  pageSub: 'New tasks appear on top · Full / Pick-only / Check-only flows',
  deviceManage: 'Devices',
  newDispatch: '+ New Dispatch',
  filterFlow: 'Flow',
  filterFlowAll: 'All Flows',
  filterFlowAllType: 'Full',
  filterFlowPickOnly: 'Pick Only',
  filterFlowChkOnly: 'Check Only',
  filterPost: 'Post',
  filterPostAll: 'All Posts',
  filterPostPick: 'Currently Picking',
  filterPostCheck: 'Currently Checking',
  filterStatus: 'Status',
  filterStatusAll: 'All',
  filterExc: 'Exception',
  filterExcAll: 'All',
  filterExcNone: 'None',
  filterKw: 'Task / Order No.',
  filterKwPlaceholder: 'Enter keyword',
  totalCount: '{n} total',
  empty: 'No matching tasks',
  colTaskNo: 'Task No.',
  colFlow: 'Flow',
  colStep: 'Current Step',
  colOrderNo: 'Order No.',
  colPickSt: 'Pick Station',
  colChkSt: 'Check Station',
  colQty: 'Qty',
  colBox: 'Frame',
  colBay: 'Bay',
  colPosition: 'Dock',
  colDevice: 'Devices',
  colPickCheck: 'Pick / Check',
  colExcType: 'Exception',
  colStatus: 'Status',
  colProgress: 'Progress',
  colCreated: 'Created',
  colAction: 'Action',
  stepPick: 'Pick',
  stepCheck: 'Check',
  statusPending: 'Pending',
  statusRunning: 'Running',
  statusHandle: 'Need Action',
  statusDone: 'Done',
  statusError: 'Error',
  stepNameNone: 'Not Started',
  stepNamePick: 'Picking',
  stepNameCheck: 'Checking',
  stepNameDone: 'Done',
  excOrder: 'Order Error',
  excScan: 'Scan Failed',
  excQty: 'Qty Mismatch',
  excMismatch: 'SKU Mismatch',
  excTimeout: 'Timeout',
  excPendingSuffix: ' · Pending',
  actionDetail: 'Details',
  actionHandle: 'Handle',
  posLeft: 'Left L',
  posRight: 'Right R',
}
